import React from 'react';
import { getArcticCoachUrl } from '../constants/config';

const AiAssistant: React.FC = () => {
  const coachUrl = getArcticCoachUrl('floating_widget');

  return (
    <div className="fixed bottom-6 right-6 z-[100] print:hidden">
      <a 
        href={coachUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform bg-slate-900 border border-slate-700 shadow-emerald-500/20 group relative"
        title="Avaa Arctic Coach"
      >
        <div className="absolute inset-0 bg-emerald-500/10 rounded-full animate-pulse-soft"></div>
        <div className="text-emerald-400 group-hover:animate-pulse relative z-10">
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
          </svg>
        </div>
        <div className="absolute right-full mr-4 bg-slate-900 border border-slate-800 text-emerald-400 text-[10px] font-black uppercase tracking-widest px-4 py-3 rounded-2xl opacity-0 group-hover:opacity-100 transition-all transform translate-x-4 group-hover:translate-x-0 whitespace-nowrap pointer-events-none shadow-2xl">
          Kysy Arctic Coachilta
        </div>
      </a>
    </div>
  );
};

export default AiAssistant;